<template>
  <v-pagination
    class="pagination"
    v-model="page"
    :length="count"
    :total-visible="totalVisible"
  ></v-pagination>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      required: true,
      validator: (val) => val > 1,
    },
  },
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    totalVisible() {
      return this.$vuetify.breakpoint.smAndDown ? 4 : 7;
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination::v-deep {
  .v-pagination {
    .v-pagination__navigation,
    .v-pagination__item {
      background-color: #f0e9ea;
      box-shadow: 0px 1px 1px 0px rgba(55, 52, 53, 0.15),
        0px 2px 2px 0px rgba(55, 52, 53, 0.12),
        0px 1px 5px 0px rgba(55, 52, 53, 0.05);
      color: var(--v-primary-base);
      font-size: 16px;
      font-weight: 400;

      &.v-pagination__item--active {
        background-color: var(--v-primary-base) !important;
        box-shadow: 0px 5px 5px 0px rgba(55, 52, 53, 0.2),
          0px 9px 10px 0px rgba(55, 52, 53, 0.1),
          0px 5px 14px 0px rgba(55, 52, 53, 0.05);
        color: white;
        font-weight: 600;
      }
    }
  }

  .v-icon {
    font-size: 14px !important;
  }
}
</style>
